import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../core/services/user.service';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard {
  constructor(public userService: UserService, public router: Router) {}
  async canActivate() {
    if (!this.userService.currentUser) {
      return true;
    } else {
      this.router.navigate(['/dashboard']);
      return false;
    }
  }
}
